
import { Placement } from '@post-office/placements-frontend/sample-placement';
export default Placement;
